"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _Navigator = _interopRequireDefault(require("../App/Navigator.js"));
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));
var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * An abstraction of Material UI's `Button`
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Button = props => {
  /**
   * Clicked.
   * 
   * @return {void}
   */
  const handleClick = () => {
    const uri = props.uri;
    if (uri) _Navigator.default.navigate(uri);else props.onClick?.(props.value, props.name);
  };

  /**
   * MUI Button API "size" to use based on override sizes
   */
  const sizeProperty = (0, _react.useMemo)(() => {
    switch (props.size) {
      case "xlarge":
      case "xxlarge":
        return "large";
      default:
        return props.size;
    }
  }, [props.size]);

  /**
   * CSS Class to use based on override sizes
   */
  const sizeClass = (0, _react.useMemo)(() => {
    switch (props.size) {
      case "xlarge":
        return _ButtonModule.default.xlarge;
      case "xxlarge":
        return _ButtonModule.default.xxlarge;
      default:
        return "";
    }
  }, [props.size]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
    className: `${props.className} ${sizeClass}`,
    color: props.color,
    disabled: props.disabled || props.loading,
    endIcon: props.endIcon ? _ReactUtils.default.render(props.endIcon) : undefined,
    onClick: handleClick,
    size: sizeProperty,
    startIcon: props.startIcon ? _ReactUtils.default.render(props.startIcon) : undefined,
    type: props.type,
    variant: props.variant,
    ...props.ButtonProps,
    children: props.label
  });
};
Button.propTypes = {
  ButtonProps: _propTypes.default.object,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]),
  disabled: _propTypes.default.bool,
  endIcon: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.node]),
  label: _propTypes.default.string,
  loading: _propTypes.default.bool,
  name: _propTypes.default.string,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(["small", "medium", "large", "xlarge", "xxlarge"]),
  startIcon: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.node]),
  type: _propTypes.default.string,
  uri: _propTypes.default.string,
  value: _propTypes.default.any,
  variant: _propTypes.default.oneOf(["text", "outlined", "contained"])
};
Button.defaultProps = {
  color: "primary",
  size: "medium",
  variant: "outlined"
};
var _default = exports.default = Button;